
import React from 'react';
import RecruiterTabs from './EntrepriseTabs';
import CandidatTabs from './CandidatTabs';
import AdminTabs from './AdminTabs';
import { useRoleMapping } from '@/hooks/useRoleMapping';

type DashboardTabsProps = {
  isCandidat: boolean;
  isEntreprise: boolean;
  isAdmin: boolean;
};

const DashboardTabs = ({ isCandidat, isEntreprise, isAdmin }: DashboardTabsProps) => {
  const { isCorporate, isIndividual } = useRoleMapping();
  
  if (isAdmin) {
    return <AdminTabs />;
  } else if (isEntreprise || isCorporate) {
    return <RecruiterTabs />;
  } else if (isCandidat || isIndividual) {
    return <CandidatTabs />;
  } else {
    // Cas par défaut si aucun rôle ne correspond
    return <div className="p-4 text-center">Tableau de bord non disponible pour votre profil.</div>;
  }
};

export default DashboardTabs;
